import React, { Component } from 'react';

class TextWithLink extends Component {

    doMatch(text) {
        const reg = /([^"=]{2}|^)((https?|ftp):\/\/\S+[^\s.,> )\];'"!?])/gim;
        const subst = '$1<a href="$2" target="_blank">$2</a>';
        return  text.replace(reg, subst);
    }

    createHtml() {
        const innerText = this.containerRef.innerText;
        const res = this.doMatch(innerText)
        this.containerRef.innerHTML = res;
    }

    componentDidUpdate() {
        this.createHtml();
    }

    componentDidMount() {
        this.createHtml();
    }

render() {

    return (
        <div ref={ref => this.containerRef = ref}>
            {this.props.text}
        </div>
    );
}

}

export default TextWithLink;


// WEBPACK FOOTER //
// ./src/components/TextWithLink.js